import { useLazyQuery, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { DeliveryConnection, DeliveryList } from 'types/api';
import { errorHandler } from 'utils/ErrorHandler';
import { GET_DELIVERY_LIST } from '..';
import { INITIAL_DELIVERY_PARAM } from '../types';

export function useQueryGetDelivery() {
  const [getDeliveryList, { refetch }] =
    useLazyQuery<DeliveryList>(GET_DELIVERY_LIST);

  const [deliveryData, setDeliveryData] = useState<DeliveryConnection>();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleGetDeliveryList = async () => {
    try {
      const response = await getDeliveryList({
        variables: { page: 1, ...INITIAL_DELIVERY_PARAM },
      });

      if (response) {
        setDeliveryData(response.data.delivery.deliveries);
        setIsLoading(false);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  useEffect(() => {
    handleGetDeliveryList();
  }, []);

  return {
    isLoading,
    deliveryData,
    refetch,
  };
}
